import type { GridColumn } from '@/components/desktop/DataGrid';
import { NOT_ON_THIS_PC } from '@/offline/availability';
import { useConnection } from '@/stores/connection';

/**
 * A document's details when they were never loaded on this PC and there is no
 * line to load them (.docs/023): what its row in the list already says, rather
 * than "Loading…" for as long as the connection is gone.
 */
export function OfflineDetails<T>({ row, columns }: { row: T; columns: ReadonlyArray<GridColumn<T>> }) {
  return (
    <div className="stack">
      <dl className="settings__facts">
        {columns.map((column) => (
          <div key={column.key}>
            <dt>{column.header}</dt>
            <dd>{column.render(row)}</dd>
          </div>
        ))}
      </dl>
      <p className="muted">
        Showing what the list holds. Its full details and history were not loaded on this PC, and need the connection.
      </p>
    </div>
  );
}

/** "Loading…" while there is a line; without one, that it was not loaded here. */
export function LoadingNote({ what = 'Loading…' }: { what?: string }) {
  const online = useConnection((s) => s.online);
  return <p className="muted">{online ? what : NOT_ON_THIS_PC}</p>;
}
